import base64url from "base64url";
import { RSA } from "hybrid-crypto-js";

export const generateKeyPair = () => {
  var rsa = new RSA();
  return new Promise((resolve, reject) => {
    var rsaKeys = {
      FE_PRI_KEY: "",
      FE_PUB_KEY: "",
    };
    try {
      rsa
        .generateKeyPairAsync()
        .then(keyPair => {
          rsaKeys.FE_PRI_KEY = base64url(keyPair.privateKey);
          rsaKeys.FE_PUB_KEY = base64url(keyPair.publicKey);
          resolve(rsaKeys);
        })
        .catch(e => {
          reject(e);
        });
    } catch (error) {
      console.log("Error generating keypair: ", error);
      reject(error);
    }
  });
};
